import { useUserContext } from "@/components/user-context";

import { LoggedInLoom } from "./logged-in";
import { LoggedOutLoom } from "./logged-out";

export const LoomSignup = () => {
    const {
        user: { isUserLoggedIn }
    } = useUserContext();

    if (isUserLoggedIn) {
        return <LoggedInLoom />;
    }

    return <LoggedOutLoom />;
};
